import { StatusCodes } from "http-status-codes"
import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../../services/api"
import { renderApplicationRoleApproverContainer } from "../../../../../components/Helpers"
import { UserContext } from "../../../../../context/UserContext"
import { ApplicationRoleApproverGet } from "../../../../../models/ApplicationRoleApprover"
import { useHashTab } from "../../../../../../hooks/useHashTab"
import { ApplicationRoleApproverDetails } from "./details_tab/ApplicationRoleApproverDetails"
import { ApplicationRoleApproverProperties } from "./properties_tab/ApplicationRoleApproverProperties"

export const ApplicationRoleApproverContainer = () => {
  const { applicationId, roleId, userId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()
  const returnURL = `/applications/${applicationId}/roles/${roleId}#approvers`

  const { activeTab, handleTabChange: handleChange } = useHashTab("details")

  const [approver, setApprover] = useState<ApplicationRoleApproverGet>()
  const firstProperty = approver?.properties?.[0]
  const hasProperties = Boolean(firstProperty && firstProperty.name !== null)

  useEffect(() => {
    if (applicationId && roleId && userId) {
      digitalManagerApi
        .get<ApplicationRoleApproverGet>(
          `/applications/${applicationId}/roles/${roleId}/approvers/${userId}`
        )
        .then((res) => {
          if (res.status === StatusCodes.OK) {
            setApprover(res.data)
          } else if (res.status === StatusCodes.NO_CONTENT) {
            navigate(returnURL)
          } else {
            // No action needed
          }
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [applicationId, navigate, returnURL, roleId, userId])

  return renderApplicationRoleApproverContainer({
    returnURL,
    approver,
    isLoadingUser,
    user,
    activeTab,
    hasRequiredParams: Boolean(applicationId && roleId && userId),
    tabItems: [
      { id: "details", label: "Details" },
      ...(hasProperties ? [{ id: "properties", label: "Properties" }] : []),
    ],
    handleTabChange: handleChange,
    detailsContent: activeTab === "details" && approver && user && (
      <ApplicationRoleApproverDetails
        approverDetails={approver}
        user={user}
        setApprover={setApprover}
      />
    ),
    additionalContent: hasProperties && approver && activeTab === "properties" && (
      <ApplicationRoleApproverProperties approver={approver} />
    ),
  })
}
